
import objectPath from 'object-path'
import initialState from './initialState'
import { favorites } from '@/utils/mapping'

const mutations = {
  setCollection(state, payload) {
    state.collection = payload.map(item => favorites.services(item))
  },
  updateCollection(state, payload) {
    state.collection = [
      ...state.collection,
      ...payload.map(item => favorites.services(item))
    ]
  },
  setCollectionFilters(state, payload) {
    state.collectionFilters = {
      ...state.collectionFilters,
      ...payload
    }
  },
  updateFavorite(state, { hotelId, favoriteId }) {
    state.collection.find(hotel => hotel.id === hotelId).favoriteId = favoriteId
  },
  removeFavorites(state, favoritesIds) {
    state.collection = state.collection.filter(item => !favoritesIds.includes(item.favoriteId))
  },
  updatePagination(state, payload) {
    state.pagination = {
      ...state.pagination,
      ...payload
    }
  },
  updateField(state, { target, value }) {
    objectPath.set(state, target, value)
  },
  updateIsLoading(state, payload) {
    state.isLoading = payload
  },
  updateIsFiltering(state, payload) {
    state.isFiltering = payload
  },
  updateIsLoadingMore(state, payload) {
    state.isLoadingMore = payload
  },
  updateIsFiltersApplied(state, payload) {
    state.isFiltersApplied = payload
  },
  updateEmptyFilteringResults(state, payload) {
    state.emptyFilteringResults = payload
  },
  updateIsFavoriteLoading(state, payload) {
    state.isFavoriteLoading = payload
  },
  enableDeleteMode(state) {
    state.deleteMode = true
  },
  disableDeleteMode(state) {
    state.deleteMode = false
  },
  updateSelectState(state, { id, currentState }) {
    state.collection.find(hotel => hotel.favoriteId === id).isSelected = !currentState
  },
  setInitialState(state) {
    this.state.favorites = {
      ...initialState()
    }
  },
  setErrors(state, { status, errors }) {
    state.loadingIsFailed = status
    state.errors = errors
  }
}

export default mutations